import React from 'react';
import './EmptyState.scss';
import { EmptyStateData, EmptyStateMode } from './models/EmptyStateData';

interface EmptyStateProps {
  emptyStateData: EmptyStateData;
  mode?: EmptyStateMode;
  className?: string | '';
}

const EmptyState: React.FC<EmptyStateProps> = ({ emptyStateData, mode = 'FULL', className = '' }) => {
  return (
    <div className={`empty-state ${className} ${mode === 'SMALL' && 'empty-state--small'}`}>
      {emptyStateData.imageClassName ? (
        <div className={`empty-state__image ${emptyStateData.imageClassName}`}></div>
      ) : (
        ''
      )}
      <div className="empty-state__title" dangerouslySetInnerHTML={{ __html: emptyStateData.title }} />
      {mode === 'SMALL' && emptyStateData.content && (
        <div
          className="empty-state__content"
          dangerouslySetInnerHTML={{ __html: emptyStateData.content }}
        />
      )}
      {emptyStateData.children && emptyStateData.children}
    </div>
  );
};

export default EmptyState;
